<template>
  <owal-panel
    :title="title"
    :content="content"
    @change="inputChanged"
  />
</template>

<script>
import OwalPanel from './OwalPanel'

export default {
  name: 'OwalInputPanel',
  components: { OwalPanel },
  props: {
    title: {
      type: String,
    },
    content: {
      type: Object,
      default: function () {
        return {
          component: undefined,
          form: undefined,
          text: 'To set up the input panel, pass a form or component, and set a change handler.',
        }
      },
    },
  },
  watch: {
    content: function () {
      this.bindToContent()
    },
  },
  mounted () {
    // this.bindToContent()
  },
  methods: {
    bindToContent () {
      if (!this.content) {
        console.log('Input panel has no content. Will not bind event handler')
        return
      }

      if (this.content.form) {
        this.content.form.onChange = this.change
      }

      if (this.content.component) {
        this.content.form.onChange = this.change
      }
    },
    inputChanged (submission) {
      this.$emit('change', submission)
    },
  },
}
</script>

<style scoped>

</style>
